@if (!readOnly) {
	<p class="ts1-rating-reminder-notes__helper">Please complete the Additional Training/Assessment Details section</p>
}

<div class="ts1-rating-reminder-notes__list">
	@for (group of responses; track group.get("noteId")?.value; let i = $index) {
		<div
			class="ts1-rating-reminder-notes__card"
			[formGroup]="group"
			[id]="noteScrollTargetId(group) || null"
			[class.ts1-rating-reminder-notes__card--highlight]="isNoteHighlighted(group)"
		>
			<p class="ts1-rating-reminder-notes__note-label">Additional Training/Assessment Details {{ i + 1 }}</p>

			@if (group.get("requireStatus")?.value) {
				<div class="ts1-rating-reminder-notes__note-text">
					@if (getNoteText(group)) {
						<span>{{ getNoteText(group) }}</span>
					} @else {
						<span class="ts1-rating-reminder-notes__note-text--empty"
							>No additional training/assessment details text.</span
						>
					}
				</div>
			} @else {
				<textarea
					class="ts1-rating-reminder-notes__note-input"
					formControlName="text"
					rows="2"
					[maxlength]="maxNoteLength"
					placeholder="Enter additional training/assessment details text"
					[readonly]="readOnly"
					(input)="onNoteTextChanged()"
				></textarea>
				@if (!readOnly) {
					<p class="ts1-rating-reminder-notes__read-only">Edit the prewritten sentence if necessary.</p>
				}
			}

			@if (group.get("requireStatus")?.value) {
				<div class="ts1-rating-reminder-notes__status-row">
					<span class="ts1-rating-reminder-notes__status-label">Status:</span>
					<div class="ts1-rating-reminder-notes__status-options">
						@for (option of statusOptions; track option.value) {
							@if (!readOnly || isActive(group, option.value)) {
								<button
									type="button"
									class="ts1-rating-reminder-notes__status-btn"
									[class.ts1-rating-reminder-notes__status-btn--selected]="isActive(group, option.value)"
									[class.ts1-rating-reminder-notes__status-btn--satisfactory]="option.value === 'satisfactory'"
									[class.ts1-rating-reminder-notes__status-btn--non-satisfactory]="option.value === 'non_satisfactory'"
									[class.ts1-rating-reminder-notes__status-btn--na]="option.value === 'na'"
									[disabled]="readOnly"
									(click)="setStatus(group, option.value)"
								>
									{{ option.label }}
								</button>
							}
						}
					</div>
				</div>
				@if (showStatusRequiredError(group)) {
					<p class="ts1-rating-reminder-notes__status-error">Please select a status.</p>
				}
			}
		</div>
	}
</div>
